<script>

import headNav from "../components/headNav.vue";
import router from '../router';
import {phoneList,getNumberModule} from "../api/api";
import {mapGetters} from "vuex";
export default {
  name: "rentPrivate",
  components:{headNav},
  computed:{...mapGetters(["userInfo"])},
  data(){
    return{
      page:1,
      total:null,
      listArr:[]
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(){
      getNumberModule({
        type:1,
        page:this.page,
        limit:12,
        // country_id:null,
      }).then(res => {
        console.log(res,'打印res')
        this.total = res.data.data.total
        this.listArr = res.data.data.data
      })
    },
    pageChange(e){
      console.log(e)
      this.page = e
      this.getList()
    },
    go(name,e){
      if(!this.userInfo.id){
        this.$message({
          message:'Please log in',
          type:'warning'
        });
        setTimeout(() => {
          router.push(
            {
              name:'login',
            }
          )
        },1000)
      }else {
        router.push(
          {
            name,
            query:{
              id:e.id,
              type:1
            }
          }
        )
      }

    }
  }
}
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <b-container fluid style="margin-bottom: 30px">
      <b-row>
        <div style="font-size: 24px;font-weight: 600;margin: 20px 0">Private Numbers</div>
<!--        <div>-->
<!--          Rent a private phone number and verify any platform online. Only you have access to the number. All our numbers are based on real sim cards. We provide flexible payment options, accepting over 100 types of cryptocurrencies, as well as PayPal and major debit/credit cards.-->
<!--        </div>-->
      </b-row>

    </b-container>
    <b-container  fluid style="margin-bottom: 20px">
      <b-row style="margin-bottom: 20px;margin-bottom: 15px">
        <b-col  v-for="(item,index) in listArr" :key="index">
          <div class="module" style="margin-bottom:15px">
            <div class="moduleHead">
              <div style="margin-right: 10px;padding: 5px 0;box-sizing: border-box">
                <img :src="item.country.image" style="width: 80px;height: 40px" alt="">
              </div>
              <div>
                <div style="font-weight: 600;font-size: 16px">{{item.country.name}}</div>
                <div style="font-size: 14px;color: #2080E4;font-weight: 600">+{{item.phone}}</div>
              </div>
            </div>
            <div class="moduleCen">
              <div>
                <div style="margin-bottom: 2px;color: #b2b1b1">30 Days</div>
                <div style="font-weight: 600">${{item.month_price}}</div>
              </div>
            </div>
            <div class="moduleFoot">
              <b-button block variant="primary" @click="go('rentRealDetail',item)">Rent number</b-button>
            </div>
          </div>
        </b-col>
      </b-row>

    </b-container>

    <b-container>
      <b-row style="margin-bottom: 20px;margin-bottom: 15px">
        <b-col sm="4" offset-sm="4">
         <div>
           <el-pagination
             background
             :page-size='12'
             layout="prev, pager, next"
             @current-change="pageChange"
             :total="total">
           </el-pagination>
         </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
.moduleFoot{
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.moduleCen{
  margin: 4px 0 ;
  padding: 10px 15px;
  box-sizing: border-box;
}
.module{
  border: 1px solid #efeeee;
  border-radius: 10px;
}
.moduleHead{
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #2080E4;
  background-color: rgba(32,128,228,0.1);
  display: flex;
  border-radius: 5px 5px 0 0 ;
}
</style>



// WEBPACK FOOTER //
// src/view/rentPrivate.vue